export enum AllergiesRadioGroupId {
  CLASSIFICATION               = 1068462,
  HIGHLIGHT_INTENSITY_SEVERITY = 1068177,
  CONDITION                    = 337193
}

export enum AllergiesRadioGroupExpressions {
  CLASSIFICATION               = 'classification',
  HIGHLIGHT_INTENSITY_SEVERITY = 'highlightIntensitySeverity',
  CONDITION                    = 'condition'
}

export enum AllergiesClassificationId {
  ALLERGY_ADVERSE_REACTION = 'A',
  INTOLERANCE              = 'I'
}

export enum AllergiesHighlightIntensitySecerityId {
  MILD_LITTLE          = 'L',
  MEDIUM_MODERATE      = 'M',
  SEVERE_LARGE         = 'I',
  UNKNOWN_NOT_INFORMED = 'D'
}

export enum AllergiesConditionId {
  CONFIRMED = 'C',
  SUSPECTED = 'S'
}

export enum AllergiesDefaultValues {
  CLASSIFICATION = AllergiesClassificationId.ALLERGY_ADVERSE_REACTION,
  HIGHLIGHT_INTENSITY_SEVERITY = AllergiesHighlightIntensitySecerityId.UNKNOWN_NOT_INFORMED,
  CONDITION = AllergiesConditionId.CONFIRMED,
}
